import Marquee from '../../plugins/gsap/marquee';

const textImagePanes = document.querySelectorAll('.pane--text-image');

textImagePanes.forEach((pane) => {
    new Marquee(pane.querySelector('.pane__marquee'), {
        end: '80% 33.33333%',
        markers: false,
    });
});
